import { useEffect } from 'react';
import { useInjector } from '~/common/useInjector';
import { useRootStore } from '~/stores/useRootStore';
import { useCXRootStore } from '~/components/ClientExperience/stores/cx-root-store.provider';

function useLoadFingerprintInjector() {
    const { Fingerprint } = useInjector(['Fingerprint']);
    return Fingerprint;
}

export function useLoadFingerprintFromAngular() {
    const { userStore } = useRootStore();
    const fingerprintService = useLoadFingerprintInjector();

    useEffect(() => {
        if (!fingerprintService) {
            return;
        }

        fingerprintService().then(fingerprint => {
            userStore.setFingerprint(fingerprint);
        });
    }, [fingerprintService, userStore]);
}

export function useLoadFingerprintFromAngularToCx() {
    const { userStore } = useCXRootStore();
    const fingerprintService = useLoadFingerprintInjector();

    useEffect(() => {
        if (!fingerprintService) {
            return;
        }

        fingerprintService().then(fingerprint => {
            userStore.setFingerprint(fingerprint);
        });
    }, [fingerprintService, userStore]);
}
